<template>
  <div class="invoicelist">
     <span class="hideOut">{{checkInvoiceType}}</span>
      <Header/>
      <div class="fixed-row top-margin"
        :class="{'with-sublevel' : $hasFeature('wallet') }"
        v-infinite-scroll="loadMore"
        infinite-scroll-disabled="loadCheck"
        infinite-scroll-throttle-delay="400"
        infinite-scroll-distance="10">
          <Row v-for="(invoice, index) in listInvoice"
          :key="index"
          :commentLoading="commentLoading"
          :comments="comments"
          @addConversation="addConversation"
          @getComments="getComments"
          :invoice="invoice"/>
        <div class="no-data" v-if="!isLoading && !listInvoice.length">No records found</div>
        <div v-if="isLoading">Loading...</div>
      </div>
    </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex';
import Header from './Header';
import Row from './Row';

export default {
  props: {
    daterange: {
      type: Array,
    },
    status: {
      type: Object,
    },
    loadCheck: false,
  },
  computed: {
    ...mapState('payment', [
      'commentLoading',
      'comments',
      'invoiceType',
    ]),
    ...mapGetters({
      listInvoice: 'payment/invoicelist',
    }),
    checkInvoiceType() {
      this.fetch();
      return this.invoiceType;
    },
  },
  components: {
    Header, Row,
  },
  data() {
    return {
      invoicelist: [],
      isLoading: false,
    };
  },
  methods: {
    loadMore() {
      this.$emit('loadData');
    },
    async fetch() {
      const clients = this.$store.state.app.data.clients;
      this.isLoading = true;
      if (clients.length > 0) {
        const [client] = clients;
        const filter = {
          client_id: client.id,
        };
        if (this.status) {
          filter.status = this.status.name;
        }
        if (this.daterange) {
          filter.from = this.daterange[0].toISOString();
          filter.to = this.daterange[1].toISOString();
        }
        if (this.invoiceType.id) {
          filter.type = this.invoiceType.id;
        }
        try {
          filter.page = 1;
          const result = await this.$store.dispatch('payment/filterInvoice', filter);
          //  this.invoicelist = result;
        } catch (err) {
          this.$error({ message: 'Unable to list invoice' });
        } finally {
          this.isLoading = false;
        }
      }
    },
    async addConversation(data) {
      try {
        const clients = this.$store.state.app.data.clients;
        const params = Object.assign(data, { client_id: clients[0].id });
        const result = await this.$store.dispatch('payment/addComment', { data: params });
        if (result.error) {
          this.$error({ message: result.error });
        }
      } catch (e) {
        // console.log(e.response);
      }
    },
    async getComments(data) {
      try {
        const clients = this.$store.state.app.data.clients;
        const params = Object.assign(data, { client_id: clients[0].id });
        const result = await this.$store.dispatch('payment/comments', { data: params });
        if (result.error) {
          this.$error({ message: result.error });
        }
      } catch (e) {
        // console.log(e.response);
      }
    },
  },
  created() {
    this.fetch();
  },
  watch: {
    daterange() {
      this.fetch();
    },
    status() {
      this.fetch();
    },
  },
};
</script>
<style lang="scss" scoped>
.fixed-row {
  position: fixed;
  padding-right: 10px;
  top: 170px;
  left: 20px;
  right: 10px;
  bottom: 0;
  overflow-x: hidden;
  overflow-y: auto;
  &.top-margin {
    top: 205px;
  }
  &.with-sublevel {
    top: 240px;
  }
}
.invoicelist {
  margin-top: 35px;
}
.hideOut{
  display: none;
}
</style>
